module.exports = __webpack_public_path__ + "static/media/IMG_1634.5610e144.JPG";